/* eslint-disable no-underscore-dangle */

import './modulesConfigReady';

type MfContainer = {
  get: (request: string) => unknown;
  init: (shareScope: unknown, initScope: unknown) => unknown;
};

function wrapContainer(c: MfContainer): MfContainer {
  return {
    get: (request: string): unknown => c.get(request),
    init: (shareScope: unknown, initScope: unknown): unknown => {
      try {
        return c.init(shareScope, initScope);
      } catch {
        return undefined;
      }
    },
  };
}

function remoteEntryUrl(base: string): string {
  const b = base.trim().replace(/\/$/, '');
  if (!b || b === 'undefined' || b === 'null') {
    throw new Error(`Invalid remote base URL: ${JSON.stringify(base)}`);
  }
  const path = `${b}/remoteEntry.js`;
  if (/^https?:\/\//i.test(b)) {
    return path;
  }
  if (b.startsWith('//')) {
    return `${window.location.protocol}${path}`;
  }
  return new URL(path, `${window.location.origin}/`).href;
}

function loadRemoteEntry(scope: string, src: string): Promise<MfContainer> {
  const w = window as unknown as Record<string, MfContainer | undefined>;
  const existing = w[scope];
  if (existing && typeof existing.get === 'function') {
    return Promise.resolve(wrapContainer(existing));
  }
  return new Promise<MfContainer>((resolve, reject) => {
    const s = document.createElement('script');
    s.async = true;
    s.src = src;
    s.onload = (): void => {
      const c = w[scope];
      if (!c || typeof c.get !== 'function') {
        reject(new Error(`Module Federation scope "${scope}" not found after loading ${src}`));
        return;
      }
      resolve(wrapContainer(c));
    };
    s.onerror = (): void => {
      reject(new Error(`Failed to load remote script ${src}`));
    };
    document.head.appendChild(s);
  });
}

window.__loadMfRemote = function loadMfRemote(scope: string, urlKey: string): Promise<MfContainer> {
  return window.__modulesConfigReady.then((): Promise<MfContainer> => {
    const modules = window.customModules;
    const base = modules && (modules as Record<string, string>)[urlKey];
    if (base == null || base === '') {
      return Promise.reject(new Error(`Missing customModules.${urlKey}`));
    }
    return loadRemoteEntry(scope, remoteEntryUrl(base));
  });
};
